var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBox
    ? _c("div", { class: _vm.mode == "pop" ? "mask" : "" }, [
        _c(
          "div",
          {
            class: _vm.mode == "pop" ? "verifybox" : "",
            style: { "max-width": parseInt(_vm.imgSize.width) + 30 + "px" },
          },
          [
            _vm.mode == "pop"
              ? _c("div", { staticClass: "verifybox-top" }, [
                  _vm._v("\n\t\t\t请完成安全验证\n\t\t\t"),
                  _c(
                    "span",
                    {
                      staticClass: "verifybox-close",
                      on: { click: _vm.closeBox },
                    },
                    [_c("i", { staticClass: "iconfont icon-close" })]
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "verifybox-bottom",
                style: { padding: _vm.mode == "pop" ? "15px" : "0" },
              },
              [
                _vm.componentType
                  ? _c(_vm.componentType, {
                      ref: "instance",
                      tag: "components",
                      attrs: {
                        arith: _vm.arith,
                        barSize: _vm.barSize,
                        blockSize: _vm.blockSize,
                        captchaType: _vm.captchaType,
                        explain: _vm.explain,
                        figure: _vm.figure,
                        imgSize: _vm.imgSize,
                        mode: _vm.mode,
                        type: _vm.verifyType,
                        vSpace: _vm.vSpace,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }